import { TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { useGetUnknownQueryKey } from "../../../hooks/useGetUnknownQueryKey";
import { UnknownSecurities } from "../../../Type";

export default function Name({ name, securityId }: UnknownSecurities) {
	const client = useQueryClient();
	const key = useGetUnknownQueryKey();

	const handleOnChangeName = ({ target }: any) => {
		client.setQueryData(key, (data?: UnknownSecurities[]) => {
			return (data || []).map((i) =>
				i.securityId === securityId ? { ...i, name: target.value } : i
			);
		});
	};

	return <TextField value={name} size='small' sx={{ width: 330 }} onChange={handleOnChangeName} />;
}
